/**
 * Prefijos internacionales para el campo de teléfono de leads.
 *
 * Réplica de mirtomex-staff (`src/components/ui/PhoneField.tsx`): México primero
 * (default), prefijos distintos entre sí para poder parsear el valor guardado.
 * El valor se persiste en formato E.164 simplificado: "+<prefijo><digitos>".
 */
export const PHONE_COUNTRIES = [
  { code: 'MX', name: 'México', dial: '+52', flag: '🇲🇽' },
  { code: 'ES', name: 'España', dial: '+34', flag: '🇪🇸' },
  { code: 'US', name: 'Estados Unidos', dial: '+1', flag: '🇺🇸' },
  { code: 'AR', name: 'Argentina', dial: '+54', flag: '🇦🇷' },
  { code: 'CO', name: 'Colombia', dial: '+57', flag: '🇨🇴' },
  { code: 'CL', name: 'Chile', dial: '+56', flag: '🇨🇱' },
  { code: 'PE', name: 'Perú', dial: '+51', flag: '🇵🇪' },
  { code: 'BR', name: 'Brasil', dial: '+55', flag: '🇧🇷' },
  { code: 'EC', name: 'Ecuador', dial: '+593', flag: '🇪🇨' },
  { code: 'VE', name: 'Venezuela', dial: '+58', flag: '🇻🇪' },
  { code: 'GT', name: 'Guatemala', dial: '+502', flag: '🇬🇹' },
  { code: 'CR', name: 'Costa Rica', dial: '+506', flag: '🇨🇷' },
];

export const DEFAULT_PHONE_DIAL = PHONE_COUNTRIES[0].dial; // +52 (MX)

// Ordenado por prefijo más largo primero, para que "+593" gane a "+59"/"+5".
const BY_LONGEST_DIAL = [...PHONE_COUNTRIES].sort((a, b) => b.dial.length - a.dial.length);

// Opciones para el <Select> de Polaris (bandera emoji + código).
export const PHONE_DIAL_OPTIONS = PHONE_COUNTRIES.map((c) => ({
  label: `${c.flag} ${c.dial}`,
  value: c.dial,
}));

// Separa un valor guardado ("+525512345678") en prefijo + número nacional.
export const splitPhone = (value) => {
  const v = (value || '').trim();
  if (v.startsWith('+')) {
    const match = BY_LONGEST_DIAL.find((c) => v.startsWith(c.dial));
    if (match) return { dial: match.dial, national: v.slice(match.dial.length).replace(/\D/g, '') };
  }
  return { dial: DEFAULT_PHONE_DIAL, national: v.replace(/\D/g, '') };
};

// Compone el valor a guardar en formato internacional (sin separadores).
// Vacío si no hay número nacional.
export const composePhone = (dial, national) => {
  const digits = (national || '').replace(/\D/g, '');
  return digits ? `${dial}${digits}` : '';
};
